// extracted by mini-css-extract-plugin
export var icon = "_b1-3";
export var subtitle = "_b1-2";
export var title = "_b1-1";
export var value = "_b1-0";